import React from "react";
import { Link } from "react-router-dom";
import { RiShoppingCart2Fill } from "react-icons/ri";
import { MdSwitchAccount } from "react-icons/md";
import { useSelector } from "react-redux";
import { useCart } from "../../context/CartContext";

const SpecialCase = () => {
  const cartCtx = useCart();
  const cartCount = cartCtx?.cartCount ?? 0;
  const products = useSelector((state) => state.orebiReducer.products);

  const toggleOrderType = () => {
    const current = localStorage.getItem("orderType") || "general_price";
    const next = current === "general_price"
      ? "wholesale_price"
      : "general_price";

    localStorage.setItem("orderType", next);
    // window.location.reload(); // optional: refresh UI to apply change globally
    window.location.href = "https://bulk.blackhewzen.com/";
  };
  return (
    <div className="fixed top-52 right-2 z-40 hidden md:flex flex-col gap-2">
      <Link to="/mobile-account">
        <div className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer">
          <div className="flex justify-center items-center">
            <MdSwitchAccount className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />

            <MdSwitchAccount className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
          </div>
          <p className="text-xs font-semibold font-titleFont">Profile</p>
        </div>
      </Link>
      {/* <Link to="/cart">
        <div className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
          <div className="flex justify-center items-center">
            <RiShoppingCart2Fill className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />

            <RiShoppingCart2Fill className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
          </div>
          <p className="text-xs font-semibold font-titleFont">Buy Now</p>
          {cartCount > 0 && (
            <p className="absolute top-1 right-2 bg-primeColor text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-semibold">
              {cartCount}
            </p>
          )}
        </div>
      </Link> */}

      <div onClick={toggleOrderType} className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
        <div className="flex justify-center items-center">
          <RiShoppingCart2Fill className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />

          <RiShoppingCart2Fill className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
        </div>
        <p className="text-xs font-semibold font-titleFont">
          Bulk
        </p>
        {/* {cartCount > 0 && (
          <p className="absolute top-1 right-2 bg-primeColor text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-semibold">
            {cartCount}
          </p>
        )} */}
      </div>

    </div>
  );
};

export default SpecialCase;
